import { render, staticRenderFns } from "./animationsItem.vue?vue&type=template&id=67c5617a&"
import script from "./animationsItem.vue?vue&type=script&lang=js&"
export * from "./animationsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports